import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useRecoilState } from "recoil";
import styled from "styled-components";
import SoundControl from "../../components/SoundControl";
import ApiController from "../../controller/ApiController";
import { useToast } from "../../controller/ToastController";
import { authState, authType } from "../../recoil/auth";
import { PushSettingType, pushSettingState } from "../../recoil/sound";
import AsyncLocalStorage from "../../utils/AsyncLocalStorage";
import { getDecryptObject } from "../../utils/crypto";

const Login = () => {
  const { id, password, uuid } = useParams();

  const showToast = useToast();
  const navigate = useNavigate();

  const [auth, setAuth] = useRecoilState<authType>(authState);
  const [pushSetting, setPushSetting] =
    useRecoilState<PushSettingType>(pushSettingState);

  const navigateMaster = () => {
    document.removeEventListener("message", handleAuth);
    navigate(`/`);
  };

  const login = async () => {
    SoundControl.playSilentSound();
    let response = await ApiController.auth.signin({
      id,
      password,
      device_uuid: uuid,
      app_type: 9,
      version: "",
    });

    if (
      response.data === undefined ||
      response.data.ok === false ||
      response.data.data === undefined
    ) {
      showToast(`[${id}]/[${password}]/[${uuid}] error`);
      return false;
    }
    AsyncLocalStorage.setItem("webBrowserLogin", "true");
    let loginInfo: authType = response.data.data;
    showToast(`user_token_id:[${loginInfo.user_token_id}]`);
    setAuth(loginInfo);
    const localPushSetting = AsyncLocalStorage.getItem("pushSetting");
    if (localPushSetting) {
      setPushSetting(localPushSetting);
    }
  };

  const handleAuth = (event: any) => {
    let message = getDecryptObject(event.data);

    if (message.type === "set_auth") {
      setAuth(message.data);
    }
  };
  document.addEventListener("message", handleAuth);

  return (
    <Style>
      <div className="knockContainer">
        <button onClick={navigateMaster} className="enterButton">
          ------------------------------
        </button>
        <button onClick={login} className="enterButton">
          LOGIN
        </button>
      </div>
    </Style>
  );
};
export default Login;

const Style = styled.div`
  .knockContainer {
    flex: 1;
    min-height: 100vh;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #000000;
    padding-bottom: 10%;
  }
  .enterButton {
    position: absolute;
    bottom: 10%;
    padding: 16px 48px;
    border: 2px solid #555555;
    background: #262626;
    border-radius: 50px;
    color: #ffffff;
    text-align: center;
    font-size: 20px;
    line-height: 24px;
    font-weight: 300;
    cursor: pointer;
  }
`;
